import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../auth.jsx";

export default function Login() {
    const { me, loading, login } = useAuth();
    const navigate = useNavigate();
    const [u, setU] = useState("");
    const [p, setP] = useState("");
    const [err, setErr] = useState(null);
    const [busy, setBusy] = useState(false);

    if (loading) return <div className="page-loading">…</div>;
    if (me)      return <Navigate to="/" replace />;

    async function submit(e) {
        e.preventDefault();
        setBusy(true);
        setErr(null);
        try {
            await login(u, p);
            navigate("/", { replace: true });
        } catch (e) {
            setErr(e.message || "login failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="login-wrap">
            <form className="login-card" onSubmit={submit}>
                <h1>UxTelemetry</h1>
                <div className="sub">Sign in to your admin panel</div>

                {err && <div className="error" style={{ marginBottom: 14 }}>{err}</div>}

                <div className="field">
                    <label htmlFor="u">Username</label>
                    <input id="u" autoFocus autoComplete="username"
                           value={u} onChange={(e) => setU(e.target.value)} />
                </div>
                <div className="field">
                    <label htmlFor="p">Password</label>
                    <input id="p" type="password" autoComplete="current-password"
                           value={p} onChange={(e) => setP(e.target.value)} />
                </div>
                <button className="primary" type="submit" disabled={busy || !u || !p}>
                    {busy ? "Signing in…" : "Sign in"}
                </button>
            </form>
        </div>
    );
}
